import { useEffect, useState } from "react";
import { api } from "../api.js";

export default function KostenScreen() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const [interval, setInterval_] = useState("monat");

  const load = () => api.list("costs").then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name || !amount) return;
    await api.createItem("costs", { name, amount: Number(amount), interval });
    setName(""); setAmount("");
    load();
  };

  const monthly = items.filter((i) => i.interval === "monat").reduce((s, i) => s + Number(i.amount), 0);
  const yearly = items.filter((i) => i.interval === "jahr").reduce((s, i) => s + Number(i.amount), 0);
  const yearlyTotal = monthly * 12 + yearly;

  return (
    <div className="dx-card">
      <div className="dx-summary-row">
        <div><span className="dx-label">Pro Monat</span><div className="dx-summary-value">{monthly.toFixed(2)} €</div></div>
        <div><span className="dx-label">Pro Jahr (hochgerechnet)</span><div className="dx-summary-value">{yearlyTotal.toFixed(2)} €</div></div>
      </div>

      <form className="dx-inline-form" onSubmit={add}>
        <input className="dx-input" placeholder="Kostenpunkt" value={name} onChange={(e) => setName(e.target.value)} />
        <input className="dx-input" placeholder="Betrag" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} />
        <select className="dx-input" value={interval} onChange={(e) => setInterval_(e.target.value)}>
          <option value="monat">pro Monat</option>
          <option value="jahr">pro Jahr</option>
        </select>
        <button className="dx-btn dx-btn--primary" type="submit">Hinzufügen</button>
      </form>

      <table className="dx-table">
        <tbody>
          {items.map((i) => (
            <tr key={i.id}>
              <td>{i.name}</td>
              <td>{Number(i.amount).toFixed(2)} €</td>
              <td>{i.interval}</td>
              <td><button className="dx-btn dx-btn--ghost" onClick={() => api.deleteItem("costs", i.id).then(load)}>Löschen</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
